import { useQuery } from "@tanstack/react-query";

import { MailSearchType } from "../enums/MailSearchType.ts";
import { useMailService } from "../services/useMailService.ts";

export function useMails(
  page: number,
  searchType: MailSearchType,
  search: string,
  mailStatus?: string[]
) {
  const { fetchMails } = useMailService();
  const queryKey = ["mails", page, searchType, search, mailStatus];
  const fetchMailsPage = async () => {
    return await fetchMails(page, searchType, search, mailStatus);
  };

  const {
    data,
    error: queryError,
    isError,
    isLoading
  } = useQuery({
    queryKey: queryKey,
    queryFn: fetchMailsPage
  });

  return {
    mails: data,
    isLoading,
    queryError,
    isError
  };
}
